module.exports = __webpack_public_path__ + "img/ch17.7bcc413d.jpg";